import React, { Component } from 'react';
import { BarLoader } from 'react-spinners';

class EventPaginator extends Component{
    render(){
        let {eventData} = this.props;

        if (eventData.to >= eventData.total) {
            return null
        }

        if (this.props.eventsAdding) {
            return <div className={'row'}>
                <div className={'col-sm-4'} />
                <div className={'col-sm-4'}>
                    <button className={'btn btn-primary btn-block btn-primary'}><BarLoader/></button>
                </div>
                <div className={'col-sm-4'} />
            </div>
        }

        return <div className={'row'}>
            <div className={'col-sm-4'} />
            <div className={'col-sm-4'}>
                <button className={'btn btn-primary btn-block btn-primary'} onClick={ ()=>this.props.appendEventsNextPage(eventData.next_page_url) }>mehr anzeigen</button>
            </div>
            <div className={'col-sm-4'} />
        </div>
    }
}

export default EventPaginator


// WEBPACK FOOTER //
// ./src/components/EventPaginator.js